module.exports = __webpack_public_path__ + "img/excelIcon.5a038fbc.svg";